<template>
  <div>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="stateAccountingPeriod" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
                <b-form-invalid-feedback id="inputFeedback">
                  {{ $t('Select accounting period') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select :options="listOfChargePolicy" v-model="selectedChargePolicy"/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="listOfCoefficientScheme" v-model="selectedCoefficientScheme" :disabled="isEdit === true">
                <template slot="first">
                  <option :value=0></option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="periodicService.cost_coef"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
              <b-input-group>
                <b-form-input type="text" v-model="periodicService.charged_in_curr_period" disabled/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Additional')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="datetime-local" v-model="periodicService.start_date" :disabled="isEdit === true"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="datetime-local" v-model="periodicService.expire_date" :disabled="infinityDate === true"/>
              <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="userHouse" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
                <b-input-group-append>
                  <b-button variant="secondary" size="sm" @click="clearHouse">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-textarea type="text" v-model="periodicService.house_comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-textarea type="text" v-model="periodicService.comment"/>
            </b-form-group>
          </b-col>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveServiceLink">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideSelectService">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse @displayHouse="displayHouse" v-model="periodicService.house_id" @hideFormHouse="hideFormHouse" @makeToasts="makeToasts"></FormHouse>
    </b-modal>

    <FormAccountinfPeriod
      @displayAccountingPeriod="displayAccountingPeriod"
      v-model="periodicService.accounting_period_id"/>

    <b-modal v-if="currentChargePolicy" ref="detailChargePolicies" hide-footer size="lg" :title="currentChargePolicy.name">
      <FormChargePolicies @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
  </div>
</template>

<script>

import moment from 'moment'
import axiosInstance from '@/utils/api.js'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormCharged from './formCharged'

export default {
  components: {
    FormHouse,
    FormAccountinfPeriod,
    FormChargePolicies,
    FormCharged
  },
  props: {
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null,
    tariffLinkId: 0,
    accountingPeriodId: 0
  },
  data () {
    return {
      selectedChargePolicy: '',
      selectedCoefficientScheme: 0,
      listOfCoefficientScheme: [],
      listOfChargePolicy: [],
      periodicServiceEdit: null,
      periodicService: {
        'house_comment': '',
        'charged_in_curr_period': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().format('YYYY-MM-DDThh:mm'),
        'expire_date': moment().format('2033-05-18T06:33'),
        'policy_id': 0,
        'house_id': 0,
        'comment': '',
        'unabon': 0,
        'cost_coef': 100,
        'slink_id': 0
      },
      userHouse: '',
      selectAccountingPeriod: '',
      houses: [],
      infinityDate: true,
      stateAccountingPeriod: false,
      currentChargePolicy: null
    }
  },
  methods: {
    displayHouse () {
      this.userHouse = ''
      for (let i in this.houses) {
        if (this.houses[i].house_id === this.periodicService.house_id) {
          let curHouse = this.houses[i]
          delete curHouse.connect_date
          delete curHouse.zones
          for (let j in curHouse) {
            if (curHouse[j].length > 0 || curHouse[j] > 0) {
              if (this.userHouse.length > 0) {
                this.userHouse += ', '
              }
              this.userHouse += curHouse[j]
            }
          }
          break
        }
      }
    },
    displayAccountingPeriod () {
      for (let i in this.accountingPeriod) {
        if (this.accountingPeriod[i].id === this.periodicService.accounting_period_id) {
          this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
          this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
          this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
        }
      }
    },
    refreshTable () {
      this.$emit('refreshTable')
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    async load () {
      if (this.isEdit) {
        this.periodicServiceEdit = await axiosInstance.get(this.$store.getters.API_USERS_SERVICELINKS_PERIODIC + '?slink_id=' + this.currentService.service_link_id).then(response => { return response.data })
        this.periodicService.start_date = moment(Number(this.periodicServiceEdit.periodicservicelink.start_date) * 1000).format('YYYY-MM-DDThh:mm')
        this.periodicService.expire_date = moment(Number(this.periodicServiceEdit.periodicservicelink.expire_date) * 1000).format('YYYY-MM-DDThh:mm')
        this.periodicService.cost_coef = this.periodicServiceEdit.periodicservicelink.cost_coef * 100
        this.periodicService.comment = this.periodicServiceEdit.periodicservicelink.comment
        this.periodicService.accounting_period_id = this.periodicServiceEdit.periodicservicelink.accounting_period_id
        this.periodicService.house_id = this.periodicServiceEdit.periodicservicelink.house_id
        this.periodicService.policy_id = this.periodicServiceEdit.periodicservicelink.policy_id
        this.periodicService.house_comment = this.periodicServiceEdit.periodicservicelink.house_comment
        this.periodicService.charged_in_curr_period = Number.parseFloat(this.periodicServiceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
        if (this.periodicServiceEdit.coefficientschedulelink) {
          this.selectedCoefficientScheme = this.periodicServiceEdit.coefficientschedulelink.scheme_id
        }
      } else {
        this.periodicService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
      }
      this.selectAccountingPeriod = ''
      this.userHouse = ''
      this.accountingPeriod = await axiosInstance.get(this.$store.getters.API_TARIFFING_ACCOUNTING_PERIODS).then(response => { return response.data })
      this.houses = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_HOUSES).then(response => { return response.data })
      let listOfChargePolicy = await axiosInstance.get(this.$store.getters.API_TARIFFING_CHARGE_POLICE).then(response => { return response.data })
      let listOfCoefficientScheme = await axiosInstance.get(this.$store.getters.API_TARIFFING_COEFFICIENT_SCHEME).then(response => { return response.data })
      for (let i in listOfCoefficientScheme) {
        listOfCoefficientScheme[i].value = listOfCoefficientScheme[i].id
        listOfCoefficientScheme[i].text = listOfCoefficientScheme[i].name
      }
      for (let i in listOfChargePolicy) {
        listOfChargePolicy[i].value = listOfChargePolicy[i].policy_id
        listOfChargePolicy[i].text = listOfChargePolicy[i].name
      }
      this.displayHouse()
      for (let i in this.accountingPeriod) {
        if (this.accountingPeriod[i].id === this.periodicService.accounting_period_id) {
          this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
          this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
          this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
        }
      }
      this.listOfCoefficientScheme = listOfCoefficientScheme
      this.listOfChargePolicy = listOfChargePolicy
      for (let i in this.listOfChargePolicy) {
        if (this.isEdit) {
          this.selectedChargePolicy = this.periodicService.policy_id
        } else {
          this.selectedChargePolicy = this.listOfChargePolicy[i].value
        }
        break
      }
    },
    async saveServiceLink () {
      if (!this.periodicService.accounting_period_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
        return
      }
      let tmpPeriodicService = JSON.parse(JSON.stringify(this.periodicService))
      for (let i in this.listOfChargePolicy) {
        if (this.selectedChargePolicy === this.listOfChargePolicy[i].value) {
          tmpPeriodicService.policy_id = this.listOfChargePolicy[i].policy_id
        }
      }
      tmpPeriodicService.cost_coef = tmpPeriodicService.cost_coef / 100
      tmpPeriodicService.start_date = Number(Date.parse(tmpPeriodicService.start_date)) / 1000
      tmpPeriodicService.expire_date = Number(Date.parse(tmpPeriodicService.expire_date)) / 1000

      tmpPeriodicService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0

      if (this.isEdit) {
        tmpPeriodicService.slink_id = this.currentService.service_link_id
        axiosInstance.put(this.$store.getters.API_USERS_SERVICELINKS_PERIODIC, tmpPeriodicService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            tmpPeriodicService = null
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideSelectService')
            this.$emit('refreshTable')
          }
        })
      } else {
        tmpPeriodicService.account_id = this.selectedAccount
        tmpPeriodicService.service_id = this.currentService.service_id
        tmpPeriodicService.user_id = this.currentUser.user_id
        let responseServiceLink = await axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_PERIODIC, tmpPeriodicService).then(response => { return response.data.service_link_id })
        if (responseServiceLink.error) {
          this.$root.$emit('makeToasts', 'danger', responseServiceLink.error, 'Error')
          tmpPeriodicService = null
          return
        } else {
          if (!this.selectedCoefficientScheme) {
            this.$root.$emit('makeToasts')
            this.$emit('hideSelectService')
            this.$emit('refreshTable')
          }
        }
        let newSlinkId = responseServiceLink
        if (this.selectedCoefficientScheme) {
          let foundCoefScheme = this.listOfCoefficientScheme.find(el => {
            return el.id === this.selectedCoefficientScheme
          })
          let coefSchedule = {
            items: []
          }
          for (let i in foundCoefScheme.items) {
            delete foundCoefScheme.items[i].scheme_id
            coefSchedule.items.push(foundCoefScheme.items[i])
          }
          let responseCoefScheduleId = await axiosInstance.post(this.$store.getters.API_TARIFFING_COEFFICIENT_SCHEDULE, coefSchedule).then(response => { return response.data.coefficient_schedule_id })
          if (responseCoefScheduleId.error) {
            this.$root.$emit('makeToasts', 'danger', responseCoefScheduleId.error, 'Error')
            tmpPeriodicService = null
            return
          }
          let newCoefScheduleId = responseCoefScheduleId
          let telephonySchedule = {
            'scheme_id': 0,
            'slink_id': 0,
            'schedule_id': 0,
            'change_policy': 0
          }
          telephonySchedule.scheme_id = this.selectedCoefficientScheme
          telephonySchedule.slink_id = Number(newSlinkId)
          telephonySchedule.schedule_id = Number(newCoefScheduleId)
          axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_COEFFICIENT_SCHEDULE, telephonySchedule).then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
              tmpPeriodicService = null
            } else {
              this.$root.$emit('makeToasts')
              this.$emit('hideSelectService')
              this.$emit('refreshTable')
            }
          })
        }
      }
    },
    showFormHouse () {
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.$refs.houseUser.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormAccountingPeriod () {
      this.$root.$emit('bv::show::modal', 'accoutingPeriod', '#btnShow')
    },
    showFormChargePolicies () {
      for (let i in this.listOfChargePolicy) {
        if (this.selectedChargePolicy === this.listOfChargePolicy[i].policy_id) {
          this.currentChargePolicy = this.listOfChargePolicy[i]
        }
      }
      this.$refs.detailChargePolicies.show()
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    clearHouse () {
      this.userHouse = ''
      this.periodicService.house_id = 0
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    selectAccountingPeriod: function (val) {
      if (this.selectAccountingPeriod.length > 0) {
        this.stateAccountingPeriod = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formPeriodic.vue